module.exports = __webpack_public_path__ + "img/mount2.721e94bf.jpg";